import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    routes: [{
            path: '/login',
            name: 'login',
            component: () =>
                import ('@/views/login/index.vue'),
            meta: {
                title: '登录',
                requiresAuth: false, // 是否需要判断是否登录
                keepAlive:true  //保持缓存
            }
        },
        {
            path: '/wechatLogin',
            name: 'wechatLogin',
            component: () =>
                import ('@/views/wechatLogin/index.vue'),
            meta: {
                title: '微信登录',
                requiresAuth: false // 是否需要判断是否登录
            }
        },
        {
            path: '/reg',
            name: 'reg',
            component: () =>
                import ('@/views/reg/index.vue'),
            meta: {
                title: '注册',
                requiresAuth: false // 是否需要判断是否登录
            }
        },
        {
            path: '/',
            name: 'home',
            component: () =>
                import ('@/views/home/index.vue'),
            meta: {
                title: '工业2025-我的工厂',
                requiresAuth: false, // 是否需要判断是否登录
            }
        },
        {
            path: '/cindex',
            name: 'home',
            component: () =>
                import ('@/views/home/cindex.vue'),
            meta: {
                title: '工业2025-我的工厂',
                requiresAuth: false, // 是否需要判断是否登录
            }
        },
        {
            path: '/modelBase',
            name: 'modelBase',
            component: () =>
                import ('@/views/home/modelBase.vue'),
            meta: {
                title: '模型仓库',
                requiresAuth: false, // 是否需要判断是否登录
            }
        },
        {
            path: '/model',
            name: 'model',
            component: () =>
                import ('@/views/home/model.vue'),
            meta: {
                title: '模型详情',
                requiresAuth: false, // 是否需要判断是否登录
            }
        },
        {
            path: '/course',
            name: 'course',
            component: () =>
                import ('@/views/home/modelCourse.vue'),
            meta: {
                title: '建模教程',
                requiresAuth: false, // 是否需要判断是否登录
            }
        },
        {
            path: '/shopcart',
            name: 'shopcart',
            component: () =>
                import ('@/views/shopcart/index.vue'),
            meta: {
                title: '购物车',
                requiresAuth: true, // 是否需要判断是否登录
                keepAlive:true  //保持缓存
            }
        },
        {
            path: '/shopcart/addorder',
            name: 'shopcartaddorder',
            component: () =>
                import ('@/views/shopcart/addorder.vue'),
            meta: {
                title: '提交订单',
                requiresAuth: true, // 是否需要判断是否登录
                keepAlive:true  //保持缓存
            }
        },
        {
            path: '/order',
            name: 'order',
            component: () =>
                import ('@/views/order/index.vue'),
            meta: {
                title: '安全支付',
                requiresAuth: true // 是否需要判断是否登录
            }
        },
        {
            path: '/order/detail',
            name: 'orderdetail',
            component: () =>
                import ('@/views/order/detail.vue'),
            meta: {
                title: '订单详情',
                requiresAuth: true // 是否需要判断是否登录
            }
        },
        {
            path: '/order/orderlist',
            name: 'orderlist',
            component: () =>
                import ('@/views/order/orderlist.vue'),
            meta: {
                title: '订单列表',
                requiresAuth: true // 是否需要判断是否登录
            }
        },
        {
            path: '/apps',
            name: 'apps',
            component: () =>
                import ('@/views/apps/index.vue'),
            meta: {
                title: '创建剖面模型',
                requiresAuth: true, // 是否需要判断是否登录
                keepAlive:false
            }
        },
        {
            path: '/contact',
            name: 'contact',
            component: () =>
                import ('@/views/contact/index.vue'),
            meta: {
                title: '通信录',
                requiresAuth: true // 是否需要判断是否登录
            }
        },
        {
            path: '/address',
            name: 'address',
            component: () =>
                import ('@/views/address/index.vue'),
            meta: {
                title: '收获地址',
                requiresAuth: true // 是否需要判断是否登录
            }
        },
        {
            path: '/self',
            name: 'self',
            component: () =>
                import ('@/views/self/index.vue'),
            meta: {
                title: '我的',
                requiresAuth: true, // 是否需要判断是否登录
                keepAlive:false  //保持缓存
            }
        },
        {
            path: '/setting',
            name: 'setting',
            component: () =>
                import ('@/views/setting/index.vue'),
            meta: {
                title: '设置',
                requiresAuth: true // 是否需要判断是否登录
            }
        },
        {
            path:'/pointDetail',
            name:'/pointDetail',
            component:()=>
                import("@/views/self/pointsDetails.vue"),
                meta:{
                title:"积分明细",
                requiresAuth:true // 是否需要判断是否登录
            }
        },
        {
            path: '/userBaseData',
            name: 'userBaseData',
            component: () =>
                import ('@/views/userBaseData/index.vue'),
            meta: {
                title: '个人信息',
                requiresAuth: true // 是否需要判断是否登录
            }
        },
        {
            path: '/changePhone',
            name: 'changePhone',
            component: () =>
                import ('@/views/changePhone/index.vue'),
            meta: {
                title: '修改手机',
                requiresAuth: true // 是否需要判断是否登录
            }
        },
        {
            path: '/bangPhone',
            name: 'bangPhone',
            component: () =>
                import ('@/views/bangPhone/index.vue'),
            meta: {
                title: '绑定手机',
                requiresAuth: true // 是否需要判断是否登录
            }
        },
        {
            path: '/changePassword',
            name: 'changePassword',
            component: () =>
                import ('@/views/changePassword/index.vue'),
            meta: {
                title: '设置登录密码',
                requiresAuth: true // 是否需要判断是否登录
            }
        },
        {
            path: '/changePaypassword',
            name: 'changePaypassword',
            component: () =>
                import ('@/views/changePaypassword/index.vue'),
            meta: {
                title: '设置支付密码',
                requiresAuth: true // 是否需要判断是否登录
            }
        },
        {
            path: '/Customer',
            name: 'Customer',
            component: () =>
                import ('@/views/Customer/index.vue'),
            meta: {
                title: '客户信息',
                requiresAuth: true // 是否需要判断是否登录
            }
        },
        {
            path: '/takephotoModel',
            name: 'takephotoModel',
            component: () =>
                import ('@/views/takephotoModel/index.vue'),
            meta: {
                title: '拍照建模',
                requiresAuth: true, // 是否需要判断是否登录
                keepAlive:true  //保持缓存
            } 
        },
        {
            path: '/workflowTaskForm',
            name: 'workflowTaskForm',
            component: () =>
                import ('@/views/workflowTaskForm/index.vue'),
            meta: {
                title: '工作流任务表单',
                requiresAuth: true // 是否需要判断是否登录
            }
        },
        {
            path: '/loginFailure',
            name: 'loginFailure',
            component: () =>
                import ('@/views/loginFailure/index.vue'),
            meta: {
                title: '登录失败'
            }
        },
        {
            path: '/downloadAPP',
            name: 'downloadAPP',
            component: () =>
                import ('@/views/downloadAPP/index.vue'),
            meta: {
                title: 'APP下载', // 是否需要判断是否登录
                keepAlive:true  //保持缓存
            }
        },
        {
            path: '/poster',
            name: 'poster',
            component: () =>
                import ('@/views/poster/index.vue'),
            meta: {
                title: '海报分享码',
                requiresAuth: true, // 是否需要判断是否登录
                keepAlive:true  //保持缓存
            }
        },
        {
            path: '/Client',
            name: 'Client',
            component: () =>
                import ('@/views/Client/index.vue'),
            meta: {
                title: '客服窗口',
                requiresAuth: true, // 是否需要判断是否登录
                keepAlive:true  //保持缓存
            }
        }
    ]
}) 


// WEBPACK FOOTER //
// ./src/router/index.js